import JSDB from '../../fromKotlin/nk';

const API_BASE = (process.env.REACT_APP_API_BASE || 'https://nihulkav.online:4000').replace(/\/$/, '');

/**
 * Fire-and-forget press / interest ping for the what's-new catalog.
 * Does not go through Kotlin coroutines so a card click always hits Flask.
 */
export function trackFeatureInterest(featureName: string, interested = false): void {
    if (!featureName) return;
    try {
        const db = JSDB();
        const user = db.getUser?.()?.first;
        const companyId = String(user?.company_id ?? db.user?.company_id ?? '');
        const token = db.getToken?.();
        if (!companyId || !token) return;

        void fetch(`${API_BASE}/users/feature_interest`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${token}`,
            },
            body: JSON.stringify({
                company_id: companyId,
                company: String(db.getCompany?.() ?? ''),
                feature_name: featureName,
                press: 1,
                interested: interested ? 1 : 0,
            }),
        }).catch(() => undefined);
    } catch {
        // tracking must never break the page
    }
}
